import React, { FunctionComponent, SVGProps } from "react";
import styled, { useTheme } from "styled-components";
import FlexBox from "ui/FlexBox";
import Body from "ui/Text/Body";

interface Props {
  label: string;
  link?: string;
  icon: FunctionComponent<SVGProps<SVGSVGElement>> | null;
  onClick?: () => void;
}

const MenuItem: React.FC<Props> = ({ label, icon: Icon, link, onClick }) => {
  const theme = useTheme();

  return (
    <a href={link} onClick={onClick}>
      <Container alignItems="center">
        {Icon && <Icon fill={theme.colors.menu.icon} width={30} />}
        <StyledBody className="ml-md" color="secondary" variant="body2">
          {label}
        </StyledBody>
      </Container>
    </a>
  );
};

export default MenuItem;

const Container = styled(FlexBox)`
  cursor: pointer;
`;

const StyledBody = styled(Body)`
  white-space: nowrap;
`;
